//Libs
import React from 'react';
import { Button, IconButton as MaterialIconButton } from '@mui/material';

// Hooks
import useUser from '../../../hooks/useUser';

// Styles
import { useStyles } from './IconButtonStyles';

const IconButton = ({
  onClick,
  startIcon,
  endIcon,
  className,
  children,
  ...props
}) => {
  const { isKiteUser } = useUser;
  const { classes, cx } = useStyles({ isKiteUser });
  return children ? (
    <Button
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      className={cx(classes.button, className)}
      {...props}>
      {children}
    </Button>
  ) : (
    <MaterialIconButton
      onClick={onClick}
      className={cx(classes.button, className)}
      {...props}>
      {startIcon}
    </MaterialIconButton>
  );
};

export default IconButton;
